import { useQuery } from '@tanstack/react-query';
import { getMasterMedicine } from '../requests';
import { MasterMedicine } from '../types';

interface UseMasterMedicineReturn {
  masterMedicine?: MasterMedicine | null;
  isLoading: boolean;
}

const useMasterMedicine = (id: string): UseMasterMedicineReturn => {
  const { data, isLoading } = useQuery({
    queryFn: () => getMasterMedicine(id),
    queryKey: ['master-medicine', id]
  });

  const masterMedicine = data?.data.data;
  const isArray = Array.isArray(masterMedicine);

  return {
    masterMedicine: masterMedicine && !isArray ? masterMedicine  : null,
    isLoading
  };
};

export default useMasterMedicine;
